import { useMutation } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import api from '@/shared/api';
import config from '@/config';
import handleHttpError from '@/shared/services/HandleHttpError';
export const useWeekPlannerPlanProposal = () => {
    const intl = useIntl();
    const { mutateAsync, isLoading, data } = useMutation(request => api.base
        .post(`${config.appUrls.tasks}/api/WeekPlanner/PlanProposal`, request)
        .then(res => res.data), {
        onError: error => {
            handleHttpError(intl)(error);
        },
    });
    return { getPlanProposal: mutateAsync, isLoading, data };
};
